// Poza pe tot ecranul, la un clic.
//
// Înainte, imaginea unei publicaţii era învelită într-un `<a href>`: clicul deschidea
// fişierul într-o filă nouă sau, la unele browsere, îl descărca. Niciuna din cele două
// nu e ce vrea omul care apasă pe o poză — el vrea s-o vadă mai mare şi să se întoarcă
// unde era.
//
// Nu e o galerie şi nu are săgeţi. O publicaţie are o singură imagine, iar butoanele
// „înainte/înapoi" pe un singur element sunt butoane care nu duc nicăieri.

import { el } from '../core/util.js';
import { icon } from './icons.js';

/** Deschide imaginea pe tot ecranul. Se închide cu Escape, cu clic în afară sau cu ✕. */
export function deschidePoza(src, optiuni = {}) {
  const { alt = '', rotund = false } = typeof optiuni === 'string' ? { alt: optiuni } : optiuni;
  document.querySelector('.lb-fundal')?.remove();

  // Avatarul se deschide rotund, ca sa se vada ce vede toata lumea — un patrat ar arata
  // colturile pe care nimeni nu le vede in aplicatie.
  const poza = el('img', { class: `lb-poza${rotund ? ' rotund' : ''}`, src, alt });
  const fundal = el('div', { class: 'lb-fundal' }, [
    el('button', { class: 'lb-inchide', title: 'Закрыть' }, [icon('close', 16)]),
    poza,
  ]);

  const inchide = () => {
    fundal.remove();
    window.removeEventListener('keydown', laTasta);
    // Derularea paginii de dedesubt a fost oprită cât timp poza era deschisă; altfel
    // roata mouse-ului mişca lenta pe sub imagine, iar la închidere erai în alt loc.
    document.body.style.overflow = derulareaVeche;
  };
  const laTasta = (e) => { if (e.key === 'Escape') inchide(); };

  // Clic pe fundal închide; clic pe poza însăşi nu — altfel n-ai putea s-o atingi.
  fundal.onclick = (e) => { if (e.target !== poza) inchide(); };
  window.addEventListener('keydown', laTasta);

  const derulareaVeche = document.body.style.overflow;
  document.body.style.overflow = 'hidden';
  document.body.append(fundal);
  return inchide;
}
